import { render } from "./UserPromocode.vue?vue&type=template&id=f42ab90a&scoped=true"
import script from "./UserPromocode.vue?vue&type=script&lang=js"
export * from "./UserPromocode.vue?vue&type=script&lang=js"

import "./UserPromocode.vue?vue&type=style&index=0&id=f42ab90a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42ab90a"]])

export default __exports__